export default __webpack_public_path__ + "static/product-unit-16-style-818ac981e287a244134569d5604fa15e.png";